import Vue from 'vue'

export const accountModes = Vue.observable({ shopId: '', modes: [], ready: false, error: '' })
export const consumeOptions = [{typeText:'按课时扣费',typeValue:'1'},{typeText:'按金额扣费',typeValue:'2'}]
let request = 0
export async function fetchAccountModes(axios, shopId) {
  if (!shopId) throw new Error('请先选择校区')
  const response = await axios.get('/sys/shop/account-modes/'+encodeURIComponent(shopId))
  const r=response&&response.data, data=r&&r.data
  if (!r||r.code!==200) throw new Error(r&&r.message||'获取账户类型失败，请重试')
  const modes=data&&data.accountModes
  if (!data||String(data.shopId)!==String(shopId)||!Array.isArray(modes)||!modes.length||modes.some(v=>!['1','2'].includes(v))) throw new Error('校区账户类型配置异常')
  return modes
}
export async function refreshAccountModes(axios, shopId) {
  const seq=++request
  Object.assign(accountModes,{shopId:String(shopId||''),modes:[],ready:false,error:''})
  try {
    const modes=await fetchAccountModes(axios,shopId)
    if(seq===request)Object.assign(accountModes,{modes,ready:true})
  } catch(e) { if(seq===request)accountModes.error=e.message }
}
export function accountModeEnabled(mode,shopId) {
  return accountModes.ready&&accountModes.shopId===String(shopId||'')&&accountModes.modes.includes(mode)
}
export function filterAccountMenus(items, modes) {
  return (items||[]).filter(item=>{
    const p=item.routePath||''
    if(p.startsWith('/financial/cash/account')||item.functionCode==='P_CASH_ACCOUNT_INDEX')return modes.includes('2')
    if(p.startsWith('/financial/course/account')||item.functionCode==='P_COURSE_ACCOUNT_INDEX')return modes.includes('1')
    return true
  }).map(item=>item.children?{...item,children:filterAccountMenus(item.children,modes)}:item)
}
